import React from 'react';

interface IRowProps {
  label: string;
  children: React.ReactNode;
}

function Row({ label, children }: IRowProps) {
  return (
    <>
      <dt>
        {label}
      </dt>
      <dd>
        {children}
      </dd>
    </>
  );
}

interface IProps {
  /* Should be one or more SellFormKeyValueList.Row components */
  children: React.ReactNode;
}

export function SellFormKeyValueList({ children }: IProps) {
  return (
    <dl className="sell-form-key-value-list">
      {children}
    </dl>
  );
}

SellFormKeyValueList.Row = Row;
